export default {"src":"/_next/static/media/book-copy.5c5e2b36.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};